export type TMerchantEnablementCompany = {
    id: string;
    name: string;
    account_number: string;
};

export type TMerchantEnablementBrand = {
    id: string;
    name: string;
    reference_name: string;
};

export enum EMerchantEnablementStatus {
    Enabled = "ENABLED", // connected and enabled
    Disabled = "DISABLED", // connected but haven't attempted enablement
    InvalidCredentials = "DISABLED_INVALID_CREDENTIALS", // connected and failed enablement
}

export type TMerchantEnablement = {
    brand: TMerchantEnablementBrand;
    company: TMerchantEnablementCompany;
    enabled_on: string;
    status: EMerchantEnablementStatus;
    user_is_member: boolean;
};

export type TMerchantEnablements = TMerchantEnablement[];
